module.exports = __webpack_public_path__ + "static/media/slide8.edc2b9be.png";